import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "m-auto px-8" }
const _hoisted_2 = { class: "m-auto" }
const _hoisted_3 = { class: "flex justify-between items-center pt-10" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "flex flex-col w-[400px]" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "flex justify-end pt-2" }
const _hoisted_9 = { class: "rotate-x-180 overflow-x-scroll" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "flex justify-end pt-2" }
const _hoisted_12 = { class: "rotate-x-180 overflow-x-scroll" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_ModalProjectFilter = _resolveComponent("ModalProjectFilter")!
  const _component_Switcher = _resolveComponent("Switcher")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_NextTable = _resolveComponent("NextTable")!
  const _component_InfiniteLoading = _resolveComponent("InfiniteLoading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_component_Loading, {
        visible: _ctx.loading||_ctx.listaMySottoProgetti.loading||_ctx.listaSottoProgetti.loading
      }, null, 8, ["visible"]),
      _createVNode(_component_ModalProjectFilter, {
        class: "z-50",
        visible: _ctx.filtri_visible,
        "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filtri_visible) = $event)),
        anno: _ctx.filtri.anno,
        "onUpdate:anno": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filtri.anno) = $event)),
        data_inizio_dal: _ctx.filtri.data_inizio_dal,
        "onUpdate:data_inizio_dal": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filtri.data_inizio_dal) = $event)),
        data_inizio_al: _ctx.filtri.data_inizio_al,
        "onUpdate:data_inizio_al": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filtri.data_inizio_al) = $event)),
        data_fine_dal: _ctx.filtri.data_fine_dal,
        "onUpdate:data_fine_dal": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filtri.data_fine_dal) = $event)),
        data_fine_al: _ctx.filtri.data_fine_al,
        "onUpdate:data_fine_al": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filtri.data_fine_al) = $event)),
        cliente: _ctx.filtri.cliente,
        "onUpdate:cliente": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filtri.cliente) = $event)),
        bu: _ctx.filtri.bu,
        "onUpdate:bu": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filtri.bu) = $event)),
        stato: _ctx.filtri.stato,
        "onUpdate:stato": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filtri.stato) = $event)),
        accounts: _ctx.filtri.accounts,
        "onUpdate:accounts": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filtri.accounts) = $event)),
        direttori: _ctx.filtri.direttori,
        "onUpdate:direttori": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.filtri.direttori) = $event)),
        pm: _ctx.filtri.pm,
        "onUpdate:pm": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.filtri.pm) = $event))
      }, null, 8, ["visible", "anno", "data_inizio_dal", "data_inizio_al", "data_fine_dal", "data_fine_al", "cliente", "bu", "stato", "accounts", "direttori", "pm"])
    ])),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Switcher, {
              modelValue: _ctx.tab_show,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.tab_show) = $event)),
              options: ['I miei sottoprogetti', 'Tutti i sottoprogetti'],
              class: "grow whitespace-nowrap mr-3"
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Field, {
                labelVisible: false,
                modelValue: _ctx.listaSottoProgetti.search,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.listaSottoProgetti.search) = $event)),
                placeholder: "Cerca nei sottoprogetti"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("i", {
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.filtri_visible = !_ctx.filtri_visible)),
                class: "pl-2 fa text-xl icon-filtri hover:text-next-orange cursor-pointer"
              }),
              _withDirectives(_createElementVNode("p", {
                class: "cursor-pointer pl-3 font-bold text-next-atp",
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.svuotaFiltri && _ctx.svuotaFiltri(...args)))
              }, "Svuota filtri", 512), [
                [_vShow, _ctx.hasFiltri]
              ])
            ])
          ])
        ]),
        (!_ctx.tab_show)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_Paginator, {
                  class: "",
                  pagination: _ctx.listaMySottoProgetti.paginate
                }, null, 8, ["pagination"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_NextTable, {
                  class: "rotate-x-180 w-full border-separate border-spacing-3 py-4",
                  cols: _ctx.sottoProgettiCols,
                  "onUpdate:cols": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.sottoProgettiCols) = $event)),
                  rows: _ctx.listaMySottoProgetti.rows,
                  onOrderUpdate: _ctx.listaMySottoProgetti.updateCols
                }, _createSlots({ _: 2 }, [
                  _renderList(_ctx.listaMySottoProgetti.rows, (c, j) => {
                    return {
                      name: `td_${j}_4`,
                      fn: _withCtx((context) => [
                        _createTextVNode(_toDisplayString(_ctx.$filters.toDate(context.context.row.data_inizio)), 1)
                      ])
                    }
                  }),
                  _renderList(_ctx.listaMySottoProgetti.rows, (c, j) => {
                    return {
                      name: `td_${j}_5`,
                      fn: _withCtx((context) => [
                        _createTextVNode(_toDisplayString(_ctx.$filters.toDate(context.context.row.data_fine)), 1)
                      ])
                    }
                  }),
                  _renderList(_ctx.listaMySottoProgetti.rows, (c, j) => {
                    return {
                      name: `td_${j}_6`,
                      fn: _withCtx((context) => [
                        _createTextVNode(_toDisplayString(_ctx.$filters.toEuroCurrency(context.context.row.budget)), 1)
                      ])
                    }
                  }),
                  _renderList(_ctx.listaMySottoProgetti.rows, (c, j) => {
                    return {
                      name: `td_${j}_8`,
                      fn: _withCtx((context) => [
                        _createVNode(_component_router_link, {
                          to: {name:'DettaglioSottoProgetto', params:{id:context.context.row.id}},
                          class: "text-center inset-0 absolute flex items-center justify-center"
                        }, {
                          default: _withCtx(() => _cache[18] || (_cache[18] = [
                            _createElementVNode("i", { class: "icon-chevron_destra" }, null, -1)
                          ])),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    }
                  })
                ]), 1032, ["cols", "rows", "onOrderUpdate"])
              ]),
              _createVNode(_component_InfiniteLoading, {
                onInfinite: _ctx.listaMySottoProgetti.fetchNextPage,
                identifier: _ctx.listaMySottoProgetti.infiniteIdentifier,
                style: {"min-height":"1px"}
              }, {
                complete: _withCtx(() => _cache[19] || (_cache[19] = [
                  _createElementVNode("div", { class: "text-center pb-3" }, "Non ci sono altri sottoprogetti.", -1)
                ])),
                _: 1
              }, 8, ["onInfinite", "identifier"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_Paginator, {
                  class: "",
                  pagination: _ctx.listaSottoProgetti.paginate
                }, null, 8, ["pagination"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_NextTable, {
                  class: "rotate-x-180 w-full border-separate border-spacing-3 py-4",
                  cols: _ctx.sottoProgettiCols,
                  "onUpdate:cols": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.sottoProgettiCols) = $event)),
                  rows: _ctx.listaSottoProgetti.rows,
                  onOrderUpdate: _ctx.listaSottoProgetti.updateCols
                }, _createSlots({ _: 2 }, [
                  _renderList(_ctx.listaSottoProgetti.rows, (c, j) => {
                    return {
                      name: `td_${j}_4`,
                      fn: _withCtx((context) => [
                        _createTextVNode(_toDisplayString(_ctx.$filters.toDate(context.context.row.data_inizio)), 1)
                      ])
                    }
                  }),
                  _renderList(_ctx.listaSottoProgetti.rows, (c, j) => {
                    return {
                      name: `td_${j}_5`,
                      fn: _withCtx((context) => [
                        _createTextVNode(_toDisplayString(_ctx.$filters.toDate(context.context.row.data_fine)), 1)
                      ])
                    }
                  }),
                  _renderList(_ctx.listaSottoProgetti.rows, (c, j) => {
                    return {
                      name: `td_${j}_6`,
                      fn: _withCtx((context) => [
                        _createTextVNode(_toDisplayString(_ctx.$filters.toEuroCurrency(context.context.row.budget)), 1)
                      ])
                    }
                  }),
                  _renderList(_ctx.listaSottoProgetti.rows, (c, j) => {
                    return {
                      name: `td_${j}_8`,
                      fn: _withCtx((context) => [
                        _createVNode(_component_router_link, {
                          to: {name:'DettaglioSottoProgetto', params:{id:context.context.row.id}},
                          class: "text-center inset-0 absolute flex items-center justify-center"
                        }, {
                          default: _withCtx(() => _cache[20] || (_cache[20] = [
                            _createElementVNode("i", { class: "icon-chevron_destra" }, null, -1)
                          ])),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    }
                  })
                ]), 1032, ["cols", "rows", "onOrderUpdate"])
              ]),
              _createVNode(_component_InfiniteLoading, {
                onInfinite: _ctx.listaSottoProgetti.fetchNextPage,
                identifier: _ctx.listaSottoProgetti.infiniteIdentifier,
                style: {"min-height":"1px"}
              }, {
                complete: _withCtx(() => _cache[21] || (_cache[21] = [
                  _createElementVNode("div", { class: "text-center pb-3" }, "Non ci sono altri sottoprogetti.", -1)
                ])),
                _: 1
              }, 8, ["onInfinite", "identifier"])
            ]))
      ])
    ])
  ], 64))
}